module.exports = __webpack_public_path__ + "static/00004.316a8400.jpg";